import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FullscreenExit = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.49.42c.58 0 1.048.473 1.048 1.058v12.396c0 1.801-1.45 3.243-3.212 3.243H1.048A1.053 1.053 0 0 1 0 16.06c0-.584.469-1.058 1.048-1.058h12.278c.613 0 1.117-.504 1.117-1.128V1.478c0-.585.47-1.058 1.048-1.058ZM28.51.42c.578 0 1.047.473 1.047 1.058v12.396c0 .619.499 1.128 1.117 1.128h12.278c.579 0 1.048.473 1.048 1.058 0 .584-.469 1.057-1.048 1.057H30.674c-1.784 0-3.212-1.465-3.212-3.243V1.478c0-.585.469-1.058 1.047-1.058ZM30.674 29.838c-.613 0-1.117.504-1.117 1.128v12.396c0 .584-.47 1.058-1.048 1.058a1.053 1.053 0 0 1-1.047-1.058V30.966c0-1.801 1.45-3.244 3.212-3.244h12.278c.579 0 1.048.474 1.048 1.058 0 .584-.469 1.058-1.048 1.058H30.674ZM0 28.78c0-.584.469-1.058 1.048-1.058h12.278c1.784 0 3.212 1.466 3.212 3.244v12.396c0 .584-.469 1.058-1.047 1.058a1.053 1.053 0 0 1-1.048-1.058V30.966c0-.619-.499-1.128-1.117-1.128H1.048A1.053 1.053 0 0 1 0 28.78Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
FullscreenExit.displayName = 'FullscreenExit';
FullscreenExit.defaultProps = {
  'aria-label': 'FullscreenExit'
};
export default FullscreenExit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FullscreenExit.js
// module id = 3800
// module chunks = 11